import check from 'check-types'
import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'
import config from 'config'

function _genericCatch() {
	return {
		error_code: -1,
		payload: {
			message: 'Something went wrong. Please try again later.',
		},
	}
}

function getBindersList(page, order_field, order_type) {
	return http_agent.post(config.services + 'userBinder/all.php')
		.send({
			page,
			order_field,
			order_type,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function searchLessons(entityUID, page, order_field, order_type, search) {
	return http_agent.post(config.services + 'userBinder/searchPresentations')
		.send({
			entityUID,
			page,
			order_field,
			order_type,
			search,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function getLessons(entityUID, page, order_field, order_type, limit = 0) {
	return http_agent.post(config.services + 'userBinder/getPresentations')
		.send({
			entityUID,
			page,
			order_field,
			order_type,
			limit,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function saveNotes(entityUID, presentationUID, notes, lessons) {
	return http_agent.post(config.services + 'userBinderPresentation/addNotes')
		.send({
			entityUID,
			presentationUID,
			lessons,
			notes: encodeURIComponent(notes),
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function deleteLesson(entityUID, presentationUIDs) {
	if (check.array(presentationUIDs)) {
		presentationUIDs = presentationUIDs.reduce(function(prev, val ) {
			return prev + ',' + val
		})
	}
	return http_agent.post(config.services + 'userBinderPresentation/delete')
		.send({
			entityUID,
			presentationUIDs,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function saveLessons(entityUID, presentationUIDs) {
	const requestPayload = {
		entityUID,
	}
	presentationUIDs = presentationUIDs.reduce(function(prev, val ) {
		return prev + ',' + val
	})
	requestPayload.presentationUIDs = presentationUIDs
	return http_agent.post(config.services + 'userBinderPresentation/save')
		.send(requestPayload)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function deleteBinder(entityUID) {
	return http_agent.post(config.services + 'userBinder/delete')
		.send({
			entityUID,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function saveForm(values) {
	return http_agent.post(config.services + 'userBinder/save')
		.send({
			...values,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function shareForm(entityUID) {
	return http_agent.post(config.services + 'userBinder/share')
		.send({
			entityUID,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function createBinder(name) {
	return http_agent.post(config.services + 'userBinder/save')
		.send({
			name,
			hasAcceptedSubsTerms: true,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function getBinderInformation(entityUID) {
	return http_agent.post(config.services + 'userBinder/getInformation')
		.send({
			entityUID,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			return response.body
		})
		.catch(err => _genericCatch(err))
}

function uploadDocument(entityUID, file) {
	const formData = new FormData()
	formData.append('entityUID', entityUID)
	formData.append('file', file)

	return http_agent.post(config.services + 'userBinder/uploadDocument')
		.send(formData)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function getLessonCodes(entityUID, presentationUID) {
	return http_agent.post(config.services + 'userBinderPresentation/getLessonCodes')
		.send({
			presentationUID,
			entityUID,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function addSubsLessons() {
	return http_agent.post(config.services + 'userBinder/addSubsLessons')
		.send()
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function sendDefaultSubplan() {
	return http_agent.post(config.services + 'userBinder/shareSamplePlan')
		.send()
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

export default {
	getBindersList,
	searchLessons,
	getLessons,
	saveNotes,
	deleteLesson,
	saveLessons,
	deleteBinder,
	saveForm,
	shareForm,
	createBinder,
	getBinderInformation,
	uploadDocument,
	getLessonCodes,
	addSubsLessons,
	sendDefaultSubplan,
}
